import { Box } from "@chakra-ui/react";
import Settings from "./Settings";
import HowItWorksBanner from "./HowItWorksBanner";

/** Settings route: banner spans the same width as the nav content shell (via App.js wrapper). */
export default function SettingsPage() {
  return (
    <>
      <Box w="100%" mt={{ base: 4, md: 2 }} mb={5} pt={{ base: 1, md: 0 }}>
        <HowItWorksBanner />
      </Box>
      <Settings />
    </>
  );
}
